import { Highlight } from '../Highlight';
import { fromCamelCaseToWords } from '../../misc/functions';
import type { Filters, Website } from '../../types';

interface DefaultCellProps {
  column: string;
  websiteData: Website;
  filters: Filters;
}

export function DefaultCell({
  column,
  websiteData,
  filters,
}: DefaultCellProps) {
  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      <Highlight
        text={websiteData[column] as string}
        highlight={filters[column]}
      />
    </td>
  );
}
